
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell-your-bag/consignment",
      function () {
        return require("private-next-pages/sell-your-bag/consignment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell-your-bag/consignment"])
      });
    }
  